import { TAGS, api } from "store/api"

export type BetaWhitelistCheckResponse = { allowed: boolean }

export const betaWhitelistAPI = api.enhanceEndpoints({
  addTagTypes: [TAGS.BETA_WHITELIST]
})

export const betaWhitelistEndpoints = betaWhitelistAPI.injectEndpoints({
  endpoints: (builder) => ({
    checkBetaWhitelist: builder.query<BetaWhitelistCheckResponse, void>({
      query: () => ({
        url: "/cod-beta-test/check",
        method: "GET"
      }),
      providesTags: [{ type: TAGS.BETA_WHITELIST, id: "CHECK" }]
    })
  })
})
